import script from "./HighlightsTarif.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightsTarif.vue?vue&type=script&setup=true&lang=js"

import "./HighlightsTarif.vue?vue&type=style&index=0&id=ebd037b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd037b8"]])

export default __exports__